/**
 * Image Tab
 */
angular.module('elogbooksDirectives').directive('elbPanelTitleTab', ['$http', 'apiClient', '$state', '$rootScope', 'elbSettings', function ($http, apiClient, $state, $rootScope, elbSettings) {
    return {
        restrict: 'AE',
        replace: true,
        scope: {
            tabTitle: '@',
            tabIcon: '@',
            iconSize: '@',
            stateName: '@',
            uiSref: '@',
            otherSrefs: '<',
            direct: '@',
            moduleEnabled: '@'
        },
        templateUrl: '/modules/directives/layout/panel-title-tab/panel-title-tab.html',
        link: function($scope, $element, $attrs) {
            $scope.visible = $scope.moduleEnabled && elbSettings.getSetting($scope.moduleEnabled) ? elbSettings.getSetting($scope.moduleEnabled).value : true;

            $scope.isActive = isActive;
            $scope.iconSize = $scope.iconSize ? $scope.iconSize : '1-1x';

            // Monitor state change so correct tab can be set active
            $rootScope.$on('$stateChangeSuccess', function() {
                $scope.isActive();
            });

            function isActive () {

                var srefComparison = $attrs.uiSref.indexOf('(') !== -1 ? $attrs.uiSref.substring(0, $attrs.uiSref.indexOf('(')) : $attrs.uiSref;

                if ($scope.otherSrefs) {
                    return $scope.otherSrefs.filter(function (value) {
                        return $scope.$root.currentState.indexOf(value) > -1;
                    })[0];
                }

                return $attrs.direct ?
                    $scope.$root.currentState === srefComparison :
                    $scope.$root.currentState.indexOf(srefComparison) > -1;
            }
        }
    }
}]);
